const searchbox = {
  data() {
    return {
      q: '',
      result: { products: [], categories: [] },
    };
  },
  methods: {
    async search() {
      if (this.q.length < 2) {
        this.result = { products: [], categories: [] };
        return;
      }
      const formData = new FormData();
      formData.append('q', this.q);

      const orderDetailsJSON = await fetch('/checks/search', {
        method: 'POST',
        body: formData,
      });

      this.result = await orderDetailsJSON.json();
    },
  },
};

window.addEventListener('DOMContentLoaded', () => {
  if (document.getElementById('searchbox')) {
    Vue.createApp(searchbox).mount('#searchbox');
  }
});

if (document.readyState !== 'loading') {
  if (document.getElementById('searchbox')) {
    Vue.createApp(searchbox).mount('#searchbox');
  }
}
